var app = angular.module('leonardo');

var ProgressBarPercentDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      progressColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.progressColor ? ConfigThemeService.getColor(scope.progressColor) : ConfigThemeService.config.theme_config.tertiaryColor;
        element.css('color', color);
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('progressBarPercent', ['ConfigThemeService', ProgressBarPercentDirective]);
